export default {"src":"/_next/static/media/humanities.a1d5080b.svg","height":78,"width":132};